// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Xhy0","info":"UpdateTermsInfo_info__o5JeZ"};